// extracted by mini-css-extract-plugin
module.exports = {"checkBoxGroup":"Slots_checkBoxGroup__yo9zW","container":"Slots_container__6E-5i"};